export default "__VITE_ASSET__C9zNQroq__"